<div class="card cliente-modal" *ngIf="datos">
  <header class="card-header card-header-primary cliente-modal__header">
    <div class="cliente-modal__header-copy">
      <h4 class="card-title"><b>Modificar cliente</b></h4>
      <p class="card-category">Complete la información comercial para convertir el prospecto en cliente.</p>
    </div>
    <button mat-icon-button type="button" class="cliente-modal__close" aria-label="Cerrar" (click)="onNoClick()">
      <mat-icon>clear</mat-icon>
    </button>
  </header>

  <div class="card-body cliente-modal__body">
    <form [formGroup]="datos" class="cliente-modal__form">
      <div class="cliente-modal__layout">
        <section class="cliente-modal__section cliente-modal__section--details">
          <header class="cliente-modal__section-header">
            <div>
              <h5><i class="material-icons">business</i> Datos del Cliente</h5>
              <p>Capture la información principal, los datos de contacto y la clave interna.</p>
            </div>
          </header>

          <div class="cliente-modal__grid cliente-modal__grid--details">
            <mat-form-field appearance="outline" class="cliente-modal__field--social">
              <mat-label>Razón social</mat-label>
              <input matInput aria-label="Razón social" type="text" maxlength="50" formControlName="rSocial" [(ngModel)]="clienteActual.razonsocial">
            </mat-form-field>

            <mat-form-field *ngIf="!esProspectoRfc" appearance="outline">
              <mat-label>RFC</mat-label>
              <input matInput aria-label="RFC" formControlName="rfc" [(ngModel)]="clienteActual.rfc" maxlength="13"
                pattern="^[A-ZÑ&]{3,4}[0-9]{2}(0[1-9]|1[0-2])(0[1-9]|[12][0-9]|3[01])[A-Z0-9]{2,3}$"
                onkeyup="this.value=this.value.toUpperCase();">
              <mat-error *ngIf="datos.controls.rfc.invalid && (datos.controls.rfc.dirty || datos.controls.rfc.touched)">
                <span *ngIf="datos.controls.rfc.errors?.required">El campo es requerido.</span>
                <span *ngIf="datos.controls.rfc.errors?.pattern">El RFC es inválido.</span>
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Nombre corto</mat-label>
              <input matInput aria-label="Nombre corto" type="text" maxlength="50" formControlName="nombre_corto"
                [(ngModel)]="clienteActual.nombre_corto" [readonly]="!!clienteActual.nombre_corto">
              <mat-error *ngIf="datos.controls.nombre_corto.dirty && datos.controls.nombre_corto.errors?.pattern">
                Solo se permiten letras y números, sin espacios.
              </mat-error>
            </mat-form-field>

            <mat-form-field *ngIf="!esProspectoRepresentante" appearance="outline">
              <mat-label>Representante</mat-label>
              <input matInput aria-label="Representante" type="text" maxlength="50" formControlName="represent" [(ngModel)]="clienteActual.representante">
            </mat-form-field>

            <mat-form-field appearance="outline" class="cliente-modal__field--email">
              <mat-label>Correo</mat-label>
              <input matInput aria-label="Correo" type="email" maxlength="50" formControlName="email" [(ngModel)]="clienteActual.email">
              <mat-error *ngIf="datos.controls.email.invalid && (datos.controls.email.dirty || datos.controls.email.touched)">
                Capture un correo válido.
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Teléfono</mat-label>
              <input matInput aria-label="Teléfono" type="text" maxlength="10" formControlName="tel" [(ngModel)]="clienteActual.telefono"
                onkeypress="return event.charCode >= 48 && event.charCode <= 57">
              <mat-error *ngIf="datos.controls.tel.invalid && (datos.controls.tel.dirty || datos.controls.tel.touched)">
                <span *ngIf="datos.controls.tel.errors?.required">El campo es requerido.</span>
                <span *ngIf="datos.controls.tel.errors?.pattern">El teléfono es inválido.</span>
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Ext. Tel.</mat-label>
              <input matInput aria-label="Ext. Tel." type="text" maxlength="3" formControlName="extensionTel" [(ngModel)]="clienteActual.extensionTel">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Nombre de contacto</mat-label>
              <input matInput aria-label="Nombre de contacto" type="text" maxlength="50" formControlName="nombreContacto" [(ngModel)]="clienteActual.nombreContacto">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Forma de contacto</mat-label>
              <input matInput aria-label="Forma de contacto" type="text" maxlength="50" formControlName="forma" [(ngModel)]="clienteActual.formacontacto">
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Clave del cliente</mat-label>
              <input matInput aria-label="Clave del cliente" type="text" maxlength="3" formControlName="idProyecto" [(ngModel)]="clienteActual.idProyecto"
                style="text-transform: uppercase;">
            </mat-form-field>
          </div>
        </section>

        <section class="cliente-modal__section cliente-modal__section--classification">
          <header class="cliente-modal__section-header">
            <div>
              <h5><i class="material-icons">tune</i> Clasificación Comercial</h5>
              <p>Configure tipo, segmento, tamaño y la condición comercial del cliente.</p>
            </div>
          </header>

          <div class="cliente-modal__grid cliente-modal__grid--classification">
            <mat-form-field appearance="outline">
              <mat-label>Tipo de cliente</mat-label>
              <mat-select [(ngModel)]="clienteActual.idtipo" formControlName="tipo">
                <mat-option *ngFor="let tipoObject of listTipos" [value]="tipoObject.id">{{ tipoObject.tipo }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Segmento de cliente</mat-label>
              <mat-select [(ngModel)]="clienteActual.idsegmento" formControlName="segmento">
                <mat-option *ngFor="let segmentoObject of listSegmentos" [value]="segmentoObject.id">{{ segmentoObject.segmento }}</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Tamaño de cliente</mat-label>
              <mat-select [(ngModel)]="clienteActual.idtamanio" formControlName="tam">
                <mat-option *ngFor="let tamObject of listTamanios" [value]="tamObject.id">{{ tamObject.de }} al {{ tamObject.al }}</mat-option>
              </mat-select>
            </mat-form-field>

            <div class="cliente-modal__radio-card">
              <div class="cliente-modal__radio-copy">
                <strong>¿Es prospecto?</strong>
                <span>Indique si continúa en fase comercial.</span>
              </div>
              <mat-radio-group class="cliente-modal__radio-group" [(ngModel)]="clienteActual.esProspecto" name="esProspecto"
                formControlName="esProspecto" (change)="onRadioCompromisoChange()">
                <mat-radio-button [value]="1">Sí</mat-radio-button>
                <mat-radio-button [value]="0">No</mat-radio-button>
              </mat-radio-group>
            </div>

            <mat-form-field appearance="outline" class="cliente-modal__field--full cliente-modal__textarea-field">
              <mat-label>Referencia</mat-label>
              <textarea matInput aria-label="Referencia" rows="5" maxlength="500" formControlName="ref" [(ngModel)]="clienteActual.comentarios"></textarea>
            </mat-form-field>

            <div class="cliente-modal__summary cliente-modal__field--full">
              <span>Cliente</span>
              <strong>{{ clienteActual.razonsocial || 'Sin nombre' }}</strong>
            </div>
          </div>
        </section>
      </div>

      <footer class="cliente-modal__actions">
        <button mat-button type="button" class="btn btn-danger" (click)="onNoClick()">
          <i class="fa fa-times-circle-o"></i> Cancelar
        </button>
        <button mat-button type="button" class="btn btn-success" [disabled]="datos.invalid" (click)="guarda()">
          Guardar <i class="material-icons">save</i>
        </button>
      </footer>
    </form>
  </div>
</div>
